import { GetVisitorIdResponse } from '../playerAnalytics/types'

export const visitorDataFactory = (visitorDataResponse?: GetVisitorIdResponse | null) => {
    if (!visitorDataResponse) return {}

    return {
        visitorId: visitorDataResponse.d_mid,
        idSyncTTL: visitorDataResponse.id_sync_ttl,
        blob: visitorDataResponse.d_blob,
        region: visitorDataResponse.dcs_region,
        ottl: visitorDataResponse.d_ottl,
        ibs: visitorDataResponse.ibs,
        subdomain: visitorDataResponse.subdomain,
        tid: visitorDataResponse.tid,
    }
}
